import { useQuery } from '@tanstack/react-query'

import Locations from 'src/client/resources/Locations'
import logger from 'src/utils/logger'

const useLocation = ({ locationId }: { locationId: number }) =>
  useQuery({
    queryKey: [
      'locations',
      {
        locationId,
      },
    ] as const,
    queryFn: async ({ queryKey: [, { locationId: lid }] }) =>
      Locations.getLocation(lid),
    onError: (error: unknown) =>
      logger.error(`WAF ${useLocation.name} - error`, { error }),
    refetchOnWindowFocus: false,
    enabled: !!locationId && !isNaN(locationId),
  })

export default useLocation
